<template>
	<div class="parent_parent">
		<div class="parent_container">
			<div v-for="user in users" :key="user.uid" class="line">
				<div class="el name">
					<a
						target="_blank"
						:href="
							'https://console.firebase.google.com/u/0/project/alduin-app/firestore/data~2Fusers~2F' +
								user.uid
						"
						>{{ user.display_name }}</a
					>
				</div>
				<div class="el phone">{{ user.phoneNumber }}</div>
				<div style="flex: 4" />
				<div class="el date">{{ compute_date(user.last_update) }}</div>
			</div>
		</div>
		<!-- <div class="dau">
			<div v-for="d in dau" :key="d.timestamp">
				<h3>
					{{ d.date }}: <b style="color: red">{{ d.count }}</b>
				</h3>
			</div>
		</div> -->
	</div>
</template>

<script>
import { get_users } from "../../firebase";

export default {
	data() {
		return { users: [], dau: null };
	},
	created() {
		const init = async () => {
			let users = await get_users();
			users.sort((a, b) => b.last_update - a.last_update);
			/* 	let dau = {};
			for (let i = 0; i < users.length; i++) {
				const date = this.get_date(users[i].last_update);

				dau[date] = dau[date] ? dau[date] + 1 : 1;
			} */
			this.users = users;
			/* this.dau = Object.keys(dau)
				.map((date) => ({
					timestamp: Date.parse(date),
					date,
					count: dau[date],
				}))
				.sort((a, b) => b.timestamp - a.timestamp);*/
		};
		init();
	},
	methods: {
		compute_date(timestamp) {
			if (!timestamp) return "INVALID DATE";
			const time = new Date(timestamp);
			return time.toString().substring(4, 24);
		},
	},
};
</script>

<style scoped>
/* Parent */
.parent_parent {
	display: flex;
	margin-top: 40px;
}

/* Individual users */
.parent_container {
	width: 100%;
}
.line {
	flex: 1;
	width: 100%;
	display: flex;
	flex-direction: row;
	padding: 8px;
	border-top: 1px solid grey;
	height: 44px;
}
.el {
	flex: 1;
	border-right: 1px solid grey;
}
.name {
	font-size: 20px;
	text-align: left;
	padding-left: 16px;
}
.phone {
}
.date {
	border: 0;
}
a {
	color: #00ff00 !important;
}
a:visited {
	color: #00ff00 !important;
}

/* DAU */
.dau {
	width: 20%;
}
.dau h3 {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 44px;
	margin: 0;
	padding: 0 20px;
	border: 1px solid red;
	border-bottom: 0;
}
</style>
